import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Add, Search } from '../../assets/icons';
import '../../assets/css/aquadoc/symptom-selector.css';
import { symptoms as predefinedSymptoms } from '../../utils/symptoms';

const SymptomSelector = ({ onAddSymptom, currentSymptom, onChange }) => {
    // const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredSymptoms, setFilteredSymptoms] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    
//     // Filter symptoms based on search term
//     useEffect(() => {
//         if (searchTerm.trim() === '') {
//             setFilteredSymptoms([]);
//             return;
//         }
        
//         const filtered = predefinedSymptoms.filter(symptom => 
//             symptom.toLowerCase().includes(searchTerm.toLowerCase())
//         );
        
//         setFilteredSymptoms(filtered);
//         setActiveIndex(-1);
//     }, [searchTerm]);
    
//     // Handle clicks outside the dropdown to close it
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setShowDropdown(false);
//             }
//         };
        
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);
    
//     const handleInputChange = (e) => {
//         const value = e.target.value;
//         setSearchTerm(value);
//         onChange({ target: { value } }); // Update parent component's state
        
//         if (value.trim() !== '') {
//             setShowDropdown(true);
//         } else {
//             setShowDropdown(false);
//         }
//     };
    
//     const handleSymptomSelect = (symptom) => {
//         onChange({ target: { value: symptom } }); // Set the input value
//         setSearchTerm(symptom);
//         setShowDropdown(false);
        
//         // Optional: immediately add the symptom
//         if (symptom.trim() !== '') {
//             onAddSymptom();
//             setSearchTerm('');
//             onChange({ target: { value: '' } }); // Clear the input
//             inputRef.current.focus();
//         }
//     };
    
//     const handleKeyDown = (e) => {
//         // Handle Enter key to add symptom
//         if (e.key === 'Enter') {
//             e.preventDefault();
            
//             if (activeIndex >= 0 && activeIndex < filteredSymptoms.length) {
//                 // If an item is selected in dropdown, use that
//                 handleSymptomSelect(filteredSymptoms[activeIndex]);
//             } else {
//                 // Otherwise use the current input value
//                 if (searchTerm.trim() !== '') {
//                     onAddSymptom();
//                     setSearchTerm('');
//                     onChange({ target: { value: '' } }); // Clear the input
//                 }
//             }
            
//             setShowDropdown(false);
//         }
        
//         // Handle arrow keys for navigation
//         else if (e.key === 'ArrowDown') {
//             e.preventDefault();
//             setActiveIndex(prev => 
//                 prev < filteredSymptoms.length - 1 ? prev + 1 : prev
//             );
//         } 
//         else if (e.key === 'ArrowUp') {
//             e.preventDefault();
//             setActiveIndex(prev => prev > 0 ? prev - 1 : 0);
//         } 
//         else if (e.key === 'Escape') {
//             setShowDropdown(false);
//         }
//     };
    
//     return (
//         <div className="symptom-selector" ref={dropdownRef}>
//             <div className="symptom-input-container">
//                 <img src={Search} alt="Search" className="search-icon" />
//                 <input 
//                     type="text"
//                     ref={inputRef}
//                     placeholder="Type to search for symptoms or add your own..."
//                     value={searchTerm}
//                     onChange={handleInputChange}
//                     onKeyDown={handleKeyDown}
//                     onFocus={() => searchTerm.trim() !== '' && setShowDropdown(true)}
//                     className="symptom-search-input"
//                 />
//                 <button 
//                     type="button" 
//                     className="add-symptom-btn"
//                     onClick={() => {
//                         if (searchTerm.trim() !== '') {
//                             onAddSymptom();
//                             setSearchTerm('');
//                             onChange({ target: { value: '' } }); // Clear the input
//                             inputRef.current.focus();
//                         }
//                     }}
//                 >
//                     <img src={Add} alt="Add symptom" />
//                 </button>
//             </div>
            
//             {showDropdown && filteredSymptoms.length > 0 && (
//                 <ul className="symptom-dropdown">
//                     {filteredSymptoms.map((symptom, index) => (
//                         <li
//                             key={index}
//                             className={activeIndex === index ? 'active' : ''}
//                             onClick={() => handleSymptomSelect(symptom)}
//                         >
//                             {symptom}
//                         </li>
//                     ))}
//                 </ul>
//             )}
            
//             {showDropdown && searchTerm.trim() !== '' && filteredSymptoms.length === 0 && (
//                 <div className="no-matches">
//                     No matching symptoms found. You can add "{searchTerm}" as a new symptom.
//                 </div>
//             )}
            
//             <small className="selector-help">
//                 Search from our list or add your own observation. Press Enter or click + to add.
//             </small>
//         </div>
//     );
// };

// export default SymptomSelector;

useEffect(() => {
    if (!currentSymptom || currentSymptom.trim() === '') {
        setFilteredSymptoms([]);
        return;
    }
    
    const filtered = predefinedSymptoms.filter(symptom => 
        symptom.toLowerCase().includes(currentSymptom.toLowerCase())
    );
    
    setFilteredSymptoms(filtered);
    setActiveIndex(-1);
}, [currentSymptom]);

// Handle clicks outside the dropdown to close it
useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

const handleInputChange = (e) => {
    const value = e.target.value;
    onChange({ target: { value } }); // Update parent component's state
    
    if (value.trim() !== '') {
        setShowDropdown(true);
    } else {
        setShowDropdown(false);
    }
};

const handleSymptomSelect = (symptom) => {
    onChange({ target: { value: symptom } }); // Set the input value
    setShowDropdown(false);
    
    // Let's not automatically add the symptom
    // User can review and click add or press enter
};

const handleKeyDown = (e) => {
    // Handle Enter key to add symptom
    if (e.key === 'Enter') {
        e.preventDefault();
        
        if (activeIndex >= 0 && activeIndex < filteredSymptoms.length) {
            // If an item is selected in dropdown, use that
            onChange({ target: { value: filteredSymptoms[activeIndex] } });
            setTimeout(() => onAddSymptom(), 0); // Add with a slight delay to ensure state update
        } else {
            // Otherwise use the current input value
            if (currentSymptom && currentSymptom.trim() !== '') {
                onAddSymptom();
            }
        }
        
        setShowDropdown(false);
    }
    
    // Handle arrow keys for navigation
    else if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActiveIndex(prev => 
            prev < filteredSymptoms.length - 1 ? prev + 1 : prev
        );
    } 
    else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActiveIndex(prev => prev > 0 ? prev - 1 : 0);
    } 
    else if (e.key === 'Escape') {
        setShowDropdown(false);
    }
};

return (
    <div className="symptom-selector" ref={dropdownRef}>
        <div className="symptom-input-container">
            <img src={Search} alt="Search" className="search-icon" />
            <input 
                type="text"
                ref={inputRef}
                placeholder="Type to search for symptoms or add your own..."
                value={currentSymptom || ''}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onFocus={() => currentSymptom && currentSymptom.trim() !== '' && setShowDropdown(true)}
                className="symptom-search-input"
            />
            <button 
                type="button" 
                className="add-symptom-btn"
                onClick={() => {
                    if (currentSymptom && currentSymptom.trim() !== '') {
                        onAddSymptom();
                        inputRef.current.focus();
                    }
                }}
            >
                <img src={Add} alt="Add symptom" />
            </button>
        </div>
        
        {showDropdown && filteredSymptoms.length > 0 && (
            <ul className="symptom-dropdown">
                {filteredSymptoms.map((symptom, index) => (
                    <li
                        key={index}
                        className={activeIndex === index ? 'active' : ''}
                        onClick={() => handleSymptomSelect(symptom)}
                    >
                        {symptom}
                    </li>
                ))}
            </ul>
        )}
        
        {showDropdown && currentSymptom && currentSymptom.trim() !== '' && filteredSymptoms.length === 0 && (
            <div className="no-matches">
                No matching symptoms found. You can add &quot;{currentSymptom}&quot; as a new symptom.
            </div>
        )}
        
        <small className="selector-help">
            Search from our list or add your own observation. Press Enter or click + to add.
        </small>
    </div>
)
};

SymptomSelector.propTypes = {
    onAddSymptom: PropTypes.func.isRequired,
    currentSymptom: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default SymptomSelector;